export default __webpack_public_path__ + "static/media/misc-books2-1440w.94c1e74d.avif";